module.exports = __webpack_public_path__ + "src/assets/img/busdextra.1d2021c5.png";